import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./LogLoginUIHelper";

const LogLoginUIContext = createContext();

export function useLogLoginUIContext() {
  return useContext(LogLoginUIContext);
}

export const LogLoginUIConsumer = LogLoginUIContext.Consumer;

export function LogLoginUIProvider({ logLoginUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initLogLogin = {
    name: "",
    organization_uuid: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initLogLogin,
    newLogLoginButtonClick: logLoginUIEvents.newLogLoginButtonClick,
    openEditLogLoginPage: logLoginUIEvents.openLogLoginRolePage,
    openLogLoginFilePage: logLoginUIEvents.openLogLoginFilePage
  };

  return (
    <LogLoginUIContext.Provider value={value}>
      {children}
    </LogLoginUIContext.Provider>
  );
}
